import axios from 'axios';

export const productInventoryApi = async (sourceStoreId, config) => {
    return await axios.get(`${process.env.REACT_APP_STONE_SHARE_URL}/inventory/?source_store_id=${sourceStoreId}`, config);
};
